
import { calcWindowHeight, adjustImageSizes} from "./Carousels.js";

export const HeaderH1 = () => {
  const HH = document.getElementById('header-h1');
  HH.addEventListener('click',function(){
    // クリックしたらページの一番上までスクロールする
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });
  const CR = document.getElementById('top-carousel');
  if (CR === null) {
    console.log('Carousel element not found (Header)');
    HH.style.backgroundColor = '#f87511';
    HH.style.color = '#ffffff';
    return;
  }
  HH.style.position = 'absolute';
  console.log('HeaderH1 calcWindowHeight');

  let windowHeight = calcWindowHeight();
  adjustImageSizes(CR);

    // スクロール位置に応じてpositionを変更
    const handleScroll = () => {
      if (window.scrollY <= windowHeight) {
        HH.style.position = 'absolute';
        HH.style.backgroundColor = 'transparent';
        document.getElementById(`toTop`).style.display = 'none';
      } else {
        HH.style.position = 'sticky';
        HH.style.backgroundColor = '#f87511';
        HH.style.top = '0'; // stickyの時にトップから0にする
        document.getElementById(`toTop`).style.display = 'block';
      }
    };
    // スクロールイベントを監視
    window.addEventListener('scroll', handleScroll);
    // ウィンドウサイズが変更されたときにwindowHeightを更新
    window.addEventListener('resize', () => {
      adjustImageSizes(CR);
    });
    // 初期状態でスクロール位置に応じてpositionを設定
    handleScroll();
}